class RemoveTherapistFromDayReq {
  constructor() {
    this.dayId = undefined;
    this.therapistId = undefined;
  }
}

export default RemoveTherapistFromDayReq;
